
import { DeviceDetection } from "@/domain/model";
import { defineComponent, PropType } from "vue";

export class DeviceDetectionRowData {
  mac?: string;
  rssi?: number;
  stay?: number;

  constructor(attrs = {}) {
    Object.assign(this, attrs);
  }
}

export default defineComponent({
  name: "Devices",
  props: {
    deviceDetections: {
      type: Array as PropType<DeviceDetectionRowData[]>,
      required: true,
    },
    rssiThreshold: {
      type: Number,
      required: false,
    },
  },
  computed: {
    weak(): (dd: DeviceDetectionRowData) => boolean {
      return (dd: DeviceDetectionRowData) => {
        if (dd.rssi === undefined || this.rssiThreshold === undefined) {
          return false;
        }
        return dd.rssi < this.rssiThreshold;
      };
    },
  },
  components: {},
});
